import { Button } from "@mui/material";
import Flex from "../../../components/Flex";
import StyledDialog from "../../../components/StyledDialog";
import "./recording-ask-modal.scss";
import { useState } from "react";
interface IsoRecordingModalProps {
  onClick: () => void;
  onCancel: () => void;
}

const IsoRecordingModal = (props: IsoRecordingModalProps) => {
  const [visible, setVisible] = useState(true);
  const { onClick, onCancel } = props;
  return (
    <StyledDialog
      open={visible}
      className="recording-iso-ask-dialog"
      title="ISO Recording Asking"
      // okText="Accept"
      // onOk={async () => {
      //   await onClick();
      //   setVisible(false);
      // }}
      // onCancel={async () => {
      //   await onCancel();
      //   setVisible(false);
      // }}
      // destroyOnClose
    >
      <Flex>
        <Button
          onClick={async () => {
            await onClick();
            setVisible(false);
          }}
        >
          Accept
        </Button>
        <Button
          onClick={async () => {
            await onCancel();
            setVisible(false);
          }}
        >
          Cancel
        </Button>
      </Flex>
      Do you want you allow Individual Cloud recording mode?
    </StyledDialog>
  );
};

export default IsoRecordingModal;
